import moment from 'moment';

// check if string id and return months in pt-br
export function monthPtBr(props: string) {
  switch (props) {
    case '01':
      return 'Janeiro';
    case '02':
      return 'Fevereiro';
    case '03':
      return 'Marco';
    case '04':
      return 'Abril';
    case '05':
      return 'Maio';
    case '06':
      return 'Junho';
    case '07':
      return 'Julho';
    case '08':
      return 'Agosto';
    case '09':
      return 'Setembro';
    case '10':
      return 'Outubro';
    case '11':
      return 'Novembro';
    case '12':
      return 'Dezembro';
    default:
      return 'Janeiro';
  }
}

// Array of months of ht year pt-br
export const MonthOfYear = [
  {
    id: 1,
    name: 'Janeiro',
  },
  {
    id: 2,
    name: 'Fevereiro',
  },
  {
    id: 3,
    name: 'Marco',
  },
  {
    id: 4,
    name: 'Abril',
  },
  {
    id: 5,
    name: 'Maio',
  },
  {
    id: 6,
    name: 'Junho',
  },
  {
    id: 7,
    name: 'Julho',
  },
  {
    id: 8,
    name: 'Agosto',
  },
  {
    id: 9,
    name: 'Setembro',
  },
  {
    id: 10,
    name: 'Outubro',
  },
  {
    id: 11,
    name: 'Novembro',
  },
  {
    id: 12,
    name: 'Dezembro',
  },
];

// Check current month and return "MM"
export function checkAtualMonth() {
  let value = '';
  const todayAtualMonth = moment(new Date());
  const todayMonth = todayAtualMonth.format('MM');
  value = monthPtBr(todayMonth);
  return value;
}

// Check curent year and return "YYYY"
export function checkAtualYear() {
  const todayAtualYear = moment(new Date());
  const todayYear = todayAtualYear.format('YYYY');
  return todayYear;
}

// Chack a initial year date and today year date, return years between data
export function yearsFromNow() {
  const now = moment(new Date());
  const init = moment('2020-06-01 00:00:00');
  let start = Number(now.format('YYYY'));
  const final = Number(init.format('YYYY'));
  const years: any = [];

  for (start; start >= final; start -= 1) {
    const object = {
      id: start,
      name: `${start}`,
    };
    years.push(object);
  }

  return years;
}

// Check current date and return formatted "YYYY-MM-DD"
export function today() {
  const todayConst = moment(new Date());
  return todayConst.format('YYYY-MM-DD');
}

// Check current date and return first day of current date
export function firstDayOfMonth() {
  const todayDayOfMonth = moment(new Date());
  const todayDay = todayDayOfMonth.format('DD');
  const firstDay = todayDayOfMonth.subtract(Number(todayDay) - 1, 'days');
  return firstDay.format('YYYY-MM-DD');
}

// Check if props is equal an item in MonthOfYear array and return id of props
export function monthIdtoString(monthString: string) {
  const id = MonthOfYear.map((month) => {
    let value = '';
    if (month.name === monthString) {
      value = month.id.toString();
    }
    return value;
  });
  return id;
}

// Get props and return "YYYY-MM"
export function yearMonth(yearString: string, monthString: string) {
  const value = `${yearString}-${monthIdtoString(monthString)}`;
  return value;
}

// Check if props is higher than current date and return true or false
export function checkIfYearMonthIsHighterThanAtual(
  yearString: string,
  monthString: string
) {
  let todayYearMonthIsHighterThanAtual = moment(new Date());
  todayYearMonthIsHighterThanAtual = todayYearMonthIsHighterThanAtual.add(
    1,
    'month'
  );
  const formattedToday = todayYearMonthIsHighterThanAtual.format('YYYY-MM');
  const receivedYearMonth = yearMonth(yearString, monthString);
  const atual = new Date(formattedToday);
  const received = new Date(receivedYearMonth);
  let value = false;
  if (atual >= received) {
    value = false;
  } else {
    value = true;
  }
  return value;
}
